import { render, staticRenderFns } from "./DocumentRequestDropZoneCard.vue?vue&type=template&id=2873c3dc"
import script from "./DocumentRequestDropZoneCard.vue?vue&type=script&lang=js"
export * from "./DocumentRequestDropZoneCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports